module.exports = __webpack_public_path__ + "static/media/notification.056f77a8.mp3";